/**
 * 헤더 «로그인» 링크의 주소·계측 — 단일 출처 (E-1 · 2026-09-26).
 *
 * Navigation.tsx 의 로그인 링크 onClick 본문을 «글자 그대로» 옮겼다. 새 헤더(ds/e/HeaderAuth)와
 * 옛 Navigation 이 같은 함수를 부른다 — 두 벌이 되면 한쪽만 바뀐다.
 *
 * ⛔ 보존 앵커(FINAL_DESIGN_E §0-2): 아래 값은 conversion/user 이벤트 집계가 읽는다.
 *    event_type 'cta_click' · cta_name 'nav_login_button' · category 'signup' · 엔드포인트 /api/events/cta
 *    · 주소의 source=nav / source=nav_signup. 이름·값을 바꾸지 말 것.
 */

/** /login?redirect=<현재 경로>&source=<source> — Navigation 과 같은 형태. */
export function navLoginHref(pathname: string, source: 'nav' | 'nav_signup' = 'nav'): string {
  return `/login?redirect=${encodeURIComponent(pathname)}&source=${source}`;
}

/** 로그인 링크 클릭 계측(sendBeacon → fetch keepalive 폴백). 실패는 삼킨다 — 이동을 막지 않는다. */
export function trackNavLoginClick(): void {
  try {
    const body = JSON.stringify({
      event_type: 'cta_click',
      cta_name: 'nav_login_button',
      category: 'signup',
      page_path: window.location.pathname,
    });
    if (typeof navigator !== 'undefined' && navigator.sendBeacon) {
      navigator.sendBeacon('/api/events/cta', new Blob([body], { type: 'application/json' }));
    } else {
      fetch('/api/events/cta', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body,
        keepalive: true,
      }).catch(() => {});
    }
  } catch {}
}
